// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"brand-banner-component_bannerContainer__1MJPv","brandBanner":"brand-banner-component_brandBanner__1xiKl"};